import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: null,
        token: null,
        auth: false,
        institucion : null,
        credentials: false,
    },
    mutations: {
        SET_USER(state, data) {
            state.user = data;
            state.auth = true;
        },
        SET_TOKEN(state, data) {
            state.token = data;
        },
        SET_AUTH(state, data){
            state.auth = data
        },
        SET_INSTITUCION(state, data){
            state.institucion = data
        },
        SET_CREDENTIAL(state, data){
            state.credentials = data
        }
    },
    actions: {
        async login({ dispatch, commit }, credentials) {
            let res = await axios.post("/login", credentials)
            .catch((e) => console.log(e));
            commit('SET_CREDENTIAL', credentials);
            return dispatch('getUser', res.data.token);
        },
        async getUser({ commit }, token) {
            if (token) {
                commit('SET_TOKEN', token);
            }
            if (!token) {
                commit('SET_AUTH', true);
                return
            }
            try {
                let response = await axios.get('/auth/user');
                commit('SET_USER', response.data.user);
            } catch (e) {
                commit('SET_TOKEN', null);
                commit('SET_USER', null);
            }
            commit('SET_AUTH', true);
        },
        setInstitucion({commit}, data){
            localStorage.setItem('institucion',JSON.stringify(data));
            commit('SET_INSTITUCION', data);
            return
        },
        logout({commit}) {
            return axios.post('auth/logout').then(() => {
                commit('SET_TOKEN', null);
                commit('SET_USER', null);
                commit('SET_INSTITUCION', null);
                localStorage.removeItem('institucion');
            })
        },
    },
    modules: {
        //auth
    }
})
